
// Sources for the armpit pain article
export const armpitPainSources = [
  {
    text: "Mayo Clinic: 'Swollen lymph nodes'",
    link: "https://www.mayoclinic.org/diseases-conditions/swollen-lymph-nodes/symptoms-causes/syc-20353902"
  },
  {
    text: "American Academy of Dermatology: 'Hidradenitis suppurativa'",
    link: "https://www.aad.org/public/diseases/a-z/hidradenitis-suppurativa-overview"
  },
  {
    text: "Cleveland Clinic: 'Intertrigo'",
    link: "https://my.clevelandclinic.org/health/diseases/17724-intertrigo"
  },
  {
    text: "American Heart Association: 'Warning Signs of a Heart Attack'",
    link: "https://www.heart.org/en/health-topics/heart-attack/warning-signs-of-a-heart-attack"
  }
];
